import { Component, Vue } from 'vue-property-decorator'
import HighFilter from '@/components/highFilter/index.vue'
import { UserModule } from '@/store/modules/user'
@Component({ name: 'BatchGeneration', components: { HighFilter } })
export default class BatchGeneration extends Vue {
  private tableData: any = [{
    date: '2016-05-03',
    name: '王小虎',
    province: '上海',
    city: '普陀区',
    address: '上海市普陀区金沙江路 1518 弄',
    zip: 200333
  }, {
    date: '2016-05-02',
    name: '王小虎',
    province: '上海',
    city: '普陀区',
    address: '上海市普陀区金沙江路 1518 弄',
    zip: 200333
  }, {
    date: '2016-05-04',
    name: '王小虎',
    province: '上海',
    city: '普陀区',
    address: '上海市普陀区金沙江路 1518 弄',
    zip: 200333
  }]

  private selectData: any = []

  // 下载
  downLoad (row: any) {
    console.log(row)
  }

  handleSelectionChange (data: any) {
    this.selectData = data
  }

  saveData () {
    console.log(this.selectData)
  }

  downData () {
    console.log(this.selectData)
  }
}
